/* THIS IS A GENERATED FILE. PLEASE DO NOT MODIFY!! */
import * as Types from '../../../../../types/dashboard-core-gqlTypes.generated.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type ApproveFundingRequestMutationVariablesGQLType = Types.Exact<{
  fundingRequestId: Types.Scalars['UUID'];
}>;


export type ApproveFundingRequestMutationGQLType = (
  { __typename?: 'Mutation' }
  & { approveFundingRequest: (
    { __typename?: 'FundingRequestResponse' }
    & Pick<Types.FundingRequestResponseGQLType, 'fundingRequestId' | 'response'>
  ) }
);

export type RejectFundingRequestMutationVariablesGQLType = Types.Exact<{
  fundingRequestId: Types.Scalars['UUID'];
}>;


export type RejectFundingRequestMutationGQLType = (
  { __typename?: 'Mutation' }
  & { rejectFundingRequest: (
    { __typename?: 'FundingRequestResponse' }
    & Pick<Types.FundingRequestResponseGQLType, 'fundingRequestId' | 'response'>
  ) }
);

export type UserApprovalActionForFundingRequestWorkflowInstanceMutationVariablesGQLType = Types.Exact<{
  action: Types.UserApprovalActionGQLType;
  userId: Types.Scalars['UUID'];
  fundingRequestId: Types.Scalars['UUID'];
  workflowInstanceId: Types.Scalars['UUID'];
}>;


export type UserApprovalActionForFundingRequestWorkflowInstanceMutationGQLType = (
  { __typename?: 'Mutation' }
  & { userApprovalActionForFundingRequestWorkflowInstance: (
    { __typename?: 'FundingRequestResponse' }
    & Pick<Types.FundingRequestResponseGQLType, 'fundingRequestId' | 'response'>
  ) }
);

export type GetWorkflowInstanceIdForFundingRequestQueryVariablesGQLType = Types.Exact<{
  fundingRequestId: Types.Scalars['UUID'];
  organizationId: Types.Scalars['UUID'];
}>;


export type GetWorkflowInstanceIdForFundingRequestQueryGQLType = (
  { __typename?: 'Query' }
  & Pick<Types.QueryGQLType, 'getWorkflowInstanceIdForFundingRequest'>
);

export type UserApprovalGroupsForFundingRequestQueryVariablesGQLType = Types.Exact<{
  fundingRequestId: Types.Scalars['UUID'];
}>;


export type UserApprovalGroupsForFundingRequestQueryGQLType = (
  { __typename?: 'Query' }
  & { userApprovalGroupsForFundingRequest: Array<(
    { __typename?: 'UserApprovalGroup' }
    & Pick<Types.UserApprovalGroupGQLType, 'id' | 'comparator'>
    & { requestedApprovals: Array<(
      { __typename?: 'RequestedUserApprovalForDomain' }
      & { user: (
        { __typename?: 'UserObject' }
        & Pick<Types.UserObjectGQLType, 'id' | 'email' | 'firstName' | 'lastName' | 'userType' | 'roleType'>
      ), state?: Types.Maybe<(
        { __typename?: 'UserApprovalState' }
        & Pick<Types.UserApprovalStateGQLType, 'status' | 'statusAt'>
      )> }
    )>, groupState?: Types.Maybe<(
      { __typename?: 'UserApprovalState' }
      & Pick<Types.UserApprovalStateGQLType, 'status' | 'statusAt'>
    )> }
  )> }
);


export const ApproveFundingRequestDocumentGQLType = gql`
    mutation ApproveFundingRequest($fundingRequestId: UUID!) {
  approveFundingRequest(fundingRequestId: $fundingRequestId) {
    fundingRequestId
    response
  }
}
    `;
export type ApproveFundingRequestMutationFnGQLType = Apollo.MutationFunction<ApproveFundingRequestMutationGQLType, ApproveFundingRequestMutationVariablesGQLType>;

/**
 * __useApproveFundingRequestMutation__
 *
 * To run a mutation, you first call `useApproveFundingRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveFundingRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveFundingRequestMutation, { data, loading, error }] = useApproveFundingRequestMutation({
 *   variables: {
 *      fundingRequestId: // value for 'fundingRequestId'
 *   },
 * });
 */
export function useApproveFundingRequestMutation(baseOptions?: Apollo.MutationHookOptions<ApproveFundingRequestMutationGQLType, ApproveFundingRequestMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveFundingRequestMutationGQLType, ApproveFundingRequestMutationVariablesGQLType>(ApproveFundingRequestDocumentGQLType, options);
      }
export type ApproveFundingRequestMutationHookResult = ReturnType<typeof useApproveFundingRequestMutation>;
export type ApproveFundingRequestMutationResultGQLType = Apollo.MutationResult<ApproveFundingRequestMutationGQLType>;
export type ApproveFundingRequestMutationOptionsGQLType = Apollo.BaseMutationOptions<ApproveFundingRequestMutationGQLType, ApproveFundingRequestMutationVariablesGQLType>;
export const RejectFundingRequestDocumentGQLType = gql`
    mutation RejectFundingRequest($fundingRequestId: UUID!) {
  rejectFundingRequest(fundingRequestId: $fundingRequestId) {
    fundingRequestId
    response
  }
}
    `;
export type RejectFundingRequestMutationFnGQLType = Apollo.MutationFunction<RejectFundingRequestMutationGQLType, RejectFundingRequestMutationVariablesGQLType>;

/**
 * __useRejectFundingRequestMutation__
 *
 * To run a mutation, you first call `useRejectFundingRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectFundingRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectFundingRequestMutation, { data, loading, error }] = useRejectFundingRequestMutation({
 *   variables: {
 *      fundingRequestId: // value for 'fundingRequestId'
 *   },
 * });
 */
export function useRejectFundingRequestMutation(baseOptions?: Apollo.MutationHookOptions<RejectFundingRequestMutationGQLType, RejectFundingRequestMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectFundingRequestMutationGQLType, RejectFundingRequestMutationVariablesGQLType>(RejectFundingRequestDocumentGQLType, options);
      }
export type RejectFundingRequestMutationHookResult = ReturnType<typeof useRejectFundingRequestMutation>;
export type RejectFundingRequestMutationResultGQLType = Apollo.MutationResult<RejectFundingRequestMutationGQLType>;
export type RejectFundingRequestMutationOptionsGQLType = Apollo.BaseMutationOptions<RejectFundingRequestMutationGQLType, RejectFundingRequestMutationVariablesGQLType>;
export const UserApprovalActionForFundingRequestWorkflowInstanceDocumentGQLType = gql`
    mutation UserApprovalActionForFundingRequestWorkflowInstance($action: UserApprovalAction!, $userId: UUID!, $fundingRequestId: UUID!, $workflowInstanceId: UUID!) {
  userApprovalActionForFundingRequestWorkflowInstance(
    action: $action
    userId: $userId
    fundingRequestId: $fundingRequestId
    workflowInstanceId: $workflowInstanceId
  ) {
    fundingRequestId
    response
  }
}
    `;
export type UserApprovalActionForFundingRequestWorkflowInstanceMutationFnGQLType = Apollo.MutationFunction<UserApprovalActionForFundingRequestWorkflowInstanceMutationGQLType, UserApprovalActionForFundingRequestWorkflowInstanceMutationVariablesGQLType>;

/**
 * __useUserApprovalActionForFundingRequestWorkflowInstanceMutation__
 *
 * To run a mutation, you first call `useUserApprovalActionForFundingRequestWorkflowInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserApprovalActionForFundingRequestWorkflowInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userApprovalActionForFundingRequestWorkflowInstanceMutation, { data, loading, error }] = useUserApprovalActionForFundingRequestWorkflowInstanceMutation({
 *   variables: {
 *      action: // value for 'action'
 *      userId: // value for 'userId'
 *      fundingRequestId: // value for 'fundingRequestId'
 *      workflowInstanceId: // value for 'workflowInstanceId'
 *   },
 * });
 */
export function useUserApprovalActionForFundingRequestWorkflowInstanceMutation(baseOptions?: Apollo.MutationHookOptions<UserApprovalActionForFundingRequestWorkflowInstanceMutationGQLType, UserApprovalActionForFundingRequestWorkflowInstanceMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserApprovalActionForFundingRequestWorkflowInstanceMutationGQLType, UserApprovalActionForFundingRequestWorkflowInstanceMutationVariablesGQLType>(UserApprovalActionForFundingRequestWorkflowInstanceDocumentGQLType, options);
      }
export type UserApprovalActionForFundingRequestWorkflowInstanceMutationHookResult = ReturnType<typeof useUserApprovalActionForFundingRequestWorkflowInstanceMutation>;
export type UserApprovalActionForFundingRequestWorkflowInstanceMutationResultGQLType = Apollo.MutationResult<UserApprovalActionForFundingRequestWorkflowInstanceMutationGQLType>;
export type UserApprovalActionForFundingRequestWorkflowInstanceMutationOptionsGQLType = Apollo.BaseMutationOptions<UserApprovalActionForFundingRequestWorkflowInstanceMutationGQLType, UserApprovalActionForFundingRequestWorkflowInstanceMutationVariablesGQLType>;
export const GetWorkflowInstanceIdForFundingRequestDocumentGQLType = gql`
    query GetWorkflowInstanceIdForFundingRequest($fundingRequestId: UUID!, $organizationId: UUID!) {
  getWorkflowInstanceIdForFundingRequest(
    fundingRequestId: $fundingRequestId
    organizationId: $organizationId
  )
}
    `;

/**
 * __useGetWorkflowInstanceIdForFundingRequestQuery__
 *
 * To run a query within a React component, call `useGetWorkflowInstanceIdForFundingRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowInstanceIdForFundingRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowInstanceIdForFundingRequestQuery({
 *   variables: {
 *      fundingRequestId: // value for 'fundingRequestId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetWorkflowInstanceIdForFundingRequestQuery(baseOptions: Apollo.QueryHookOptions<GetWorkflowInstanceIdForFundingRequestQueryGQLType, GetWorkflowInstanceIdForFundingRequestQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkflowInstanceIdForFundingRequestQueryGQLType, GetWorkflowInstanceIdForFundingRequestQueryVariablesGQLType>(GetWorkflowInstanceIdForFundingRequestDocumentGQLType, options);
      }
export function useGetWorkflowInstanceIdForFundingRequestLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkflowInstanceIdForFundingRequestQueryGQLType, GetWorkflowInstanceIdForFundingRequestQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkflowInstanceIdForFundingRequestQueryGQLType, GetWorkflowInstanceIdForFundingRequestQueryVariablesGQLType>(GetWorkflowInstanceIdForFundingRequestDocumentGQLType, options);
        }
export type GetWorkflowInstanceIdForFundingRequestQueryHookResult = ReturnType<typeof useGetWorkflowInstanceIdForFundingRequestQuery>;
export type GetWorkflowInstanceIdForFundingRequestLazyQueryGQLTypeHookResult = ReturnType<typeof useGetWorkflowInstanceIdForFundingRequestLazyQueryGQLType>;
export type GetWorkflowInstanceIdForFundingRequestQueryResultGQLType = Apollo.QueryResult<GetWorkflowInstanceIdForFundingRequestQueryGQLType, GetWorkflowInstanceIdForFundingRequestQueryVariablesGQLType>;
export const UserApprovalGroupsForFundingRequestDocumentGQLType = gql`
    query UserApprovalGroupsForFundingRequest($fundingRequestId: UUID!) {
  userApprovalGroupsForFundingRequest(fundingRequestId: $fundingRequestId) {
    id
    comparator
    requestedApprovals {
      user {
        id
        email
        firstName
        lastName
        userType
        roleType
      }
      state {
        status
        statusAt
      }
    }
    groupState {
      status
      statusAt
    }
  }
}
    `;

/**
 * __useUserApprovalGroupsForFundingRequestQuery__
 *
 * To run a query within a React component, call `useUserApprovalGroupsForFundingRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserApprovalGroupsForFundingRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserApprovalGroupsForFundingRequestQuery({
 *   variables: {
 *      fundingRequestId: // value for 'fundingRequestId'
 *   },
 * });
 */
export function useUserApprovalGroupsForFundingRequestQuery(baseOptions: Apollo.QueryHookOptions<UserApprovalGroupsForFundingRequestQueryGQLType, UserApprovalGroupsForFundingRequestQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserApprovalGroupsForFundingRequestQueryGQLType, UserApprovalGroupsForFundingRequestQueryVariablesGQLType>(UserApprovalGroupsForFundingRequestDocumentGQLType, options);
      }
export function useUserApprovalGroupsForFundingRequestLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<UserApprovalGroupsForFundingRequestQueryGQLType, UserApprovalGroupsForFundingRequestQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserApprovalGroupsForFundingRequestQueryGQLType, UserApprovalGroupsForFundingRequestQueryVariablesGQLType>(UserApprovalGroupsForFundingRequestDocumentGQLType, options);
        }
export type UserApprovalGroupsForFundingRequestQueryHookResult = ReturnType<typeof useUserApprovalGroupsForFundingRequestQuery>;
export type UserApprovalGroupsForFundingRequestLazyQueryGQLTypeHookResult = ReturnType<typeof useUserApprovalGroupsForFundingRequestLazyQueryGQLType>;
export type UserApprovalGroupsForFundingRequestQueryResultGQLType = Apollo.QueryResult<UserApprovalGroupsForFundingRequestQueryGQLType, UserApprovalGroupsForFundingRequestQueryVariablesGQLType>;